module.exports = __webpack_public_path__ + "img/transfer-success.41c72da6.png";